import React, { useState } from 'react';

import { Spacer } from '@zillow/constellation';
import { Checkbox, Label, LabeledControl } from '@zillow/constellation-10';

type handleChangeArgs = {
  name: string;
  value: boolean;
};

type AdditionalBrokerInformationProps = {
  isListingExclusive: boolean;
  name?: string;
  onChange: (args: handleChangeArgs) => void;
};

const AdditionalBrokerInformation = ({
  isListingExclusive,
  name = 'isListingExclusive',
  onChange,
}: AdditionalBrokerInformationProps) => {
  const [checked, setChecked] = useState(isListingExclusive);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name },
    } = event;
    const value = !checked;

    setChecked(value);
    onChange({ name, value });
  };

  return (
    <div data-testid="AdditionalBrokerInformation">
      <Label>Additional broker information</Label>
      <Spacer marginY="xs">
        <LabeledControl
          controlId="LabeledControl-exclusive-listing"
          label={<Label>Listing is exclusive</Label>}
          control={<Checkbox name={name} onChange={handleChange} checked={checked} />}
        />
      </Spacer>
    </div>
  );
};

export default AdditionalBrokerInformation;
